import { matchPath } from 'react-router';

import { ROUTES } from '#constants/routes';

export const getCurrentRoute = route =>
  Object.values(ROUTES).find(aRoute => matchPath(route?.pathname || location.pathname, aRoute));
